/**
 * Return a date object for the provided UTC time string.
 * @param {string} timeString
 * @returns {Date}
 */
export const UTCTimeStringToDate = timeString => {
  const parts = timeString.split(':');
  const date = new Date();
  const [hours, minutes, seconds] = parts;

  if (hours) {
    date.setUTCHours(parseInt(hours, 10));
  }

  if (minutes) {
    date.setUTCMinutes(parseInt(minutes, 10));
  }

  if (seconds) {
    date.setUTCSeconds(parseInt(seconds, 10));
  }

  return date;
};

/**
 * Return a date object for the provided time string.
 * @param {string} timeString
 * @returns {Date}
 */
export default timeString => {
  const parts = timeString.split(':');
  const date = new Date();
  const [hours, minutes, seconds] = parts;

  if (hours) {
    date.setHours(parseInt(hours, 10));
  }

  if (minutes) {
    date.setMinutes(parseInt(minutes, 10));
  }

  if (seconds) {
    date.setSeconds(parseInt(seconds, 10));
  }

  return date;
};
